<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.077 23.3335C11.4034 23.3335 10.8333 23.1002 10.3667 22.6335C9.9 22.1668 9.66667 21.5967 9.66667 20.9232V5.74383C9.66667 5.07027 9.9 4.50016 10.3667 4.0335C10.8333 3.56683 11.4034 3.3335 12.077 3.3335H23.2563C23.9299 3.3335 24.5 3.56683 24.9667 4.0335C25.4333 4.50016 25.6667 5.07027 25.6667 5.74383V20.9232C25.6667 21.5967 25.4333 22.1668 24.9667 22.6335C24.5 23.1002 23.9299 23.3335 23.2563 23.3335H12.077ZM12.077 21.3335H23.2563C23.359 21.3335 23.453 21.2907 23.5383 21.2052C23.6239 21.1198 23.6667 21.0258 23.6667 20.9232V5.74383C23.6667 5.64116 23.6239 5.54716 23.5383 5.46183C23.453 5.37627 23.359 5.3335 23.2563 5.3335H12.077C11.9743 5.3335 11.8803 5.37627 11.795 5.46183C11.7094 5.54716 11.6667 5.64116 11.6667 5.74383V20.9232C11.6667 21.0258 11.7094 21.1198 11.795 21.2052C11.8803 21.2907 11.9743 21.3335 12.077 21.3335ZM7.41033 28.0002C6.73678 28.0002 6.16667 27.7668 5.7 27.3002C5.23333 26.8335 5 26.2634 5 25.5898V9.4105C5 9.12672 5.09578 8.88905 5.28733 8.6975C5.47867 8.50616 5.71622 8.4105 6 8.4105C6.28378 8.4105 6.52144 8.50616 6.713 8.6975C6.90433 8.88905 7 9.12672 7 9.4105V25.5898C7 25.6925 7.04278 25.7865 7.12833 25.8718C7.21367 25.9574 7.30767 26.0002 7.41033 26.0002H19.5897C19.8734 26.0002 20.1111 26.0958 20.3027 26.2872C20.494 26.4787 20.5897 26.7164 20.5897 27.0002C20.5897 27.2839 20.494 27.5215 20.3027 27.7128C20.1111 27.9044 19.8734 28.0002 19.5897 28.0002H7.41033Z"
      fill="#F18E35"
    />
  </svg>
</template>

<script>
export default {
  name: "ContentCopyIcon",
};
</script>

<style scoped></style>
